import React, { useMemo } from 'react';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import { useGetLimits } from './useGetLimits';

import style from '../ResponsibleGamingHistory.scss';

export const useTableData = () => {
    const limits = useGetLimits();
    const translate = useComponentTranslations();

    const getLimitDetailsBlock = (limit, startDate) => (
        <>
            <div className={style.limit}>{limit}</div>
            <div className={style.startDate}>{startDate}</div>
        </>
    );

    const getAccordionCell = (name, value) => (
        <>
            <div className={style.bodyCell}>{name}</div>
            <div className={style.bodyCell}>{value}</div>
        </>
    );

    return useMemo(() => ({
        tableView: {
            headerCells: [
                { id: 0, content: translate('table.head.type'), className: style.type },
                { id: 1, content: translate('table.head.period'), className: style.period },
                { id: 2, content: translate('table.head.limit') },
                { id: 3, content: translate('table.head.startDate') },
                { id: 4, content: translate('table.head.endDate') },
                { id: 5, content: translate('table.head.products') }
            ],
            rows: limits.map(item => {
                const { id, type, limit, period, products = '', endDate, startDate } = item;

                return {
                    id,
                    rowCells: [
                        { id: 0, content: type, className: style.type },
                        { id: 1, content: period, className: style.period },
                        { id: 2, content: limit },
                        { id: 3, content: startDate },
                        { id: 4, content: endDate },
                        { id: 5, content: products, className: style.products }
                    ]
                };
            })
        },
        accordionView: {
            rows: limits.map(item => {
                const { id, type, limit, period, products = '', endDate, startDate } = item;

                return {
                    id,
                    headerCells: [
                        {
                            id: 0,
                            content: type,
                            className: `${style.type} ${style.smallDetails}`
                        },
                        {
                            id: 1,
                            className: style.smallDetails,
                            content: getLimitDetailsBlock(limit, startDate)
                        }
                    ],
                    rowCells: [
                        { id: 0, content: getAccordionCell(translate('table.head.period'), period) },
                        { id: 1, content: getAccordionCell(translate('table.head.endDate'), endDate) },
                        { id: 2, content: getAccordionCell(translate('table.head.products'), products) }
                    ]
                };
            })
        }
    }), [limits, translate]);
};
